import { Link } from 'react-router-dom';

interface BreadcrumbProps {
  items: { label: string; href?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-base"></i>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}